import React from 'react';
import { TextInput, Stack, Text, Group } from '@mantine/core';

function EditCampaignForm({ formData, errors, onInputChange }) {
  return (
    <Stack gap="xs">
      <Group>
        <Text fw={600}>Campaign Name:</Text>
        <TextInput
          required
          placeholder="Enter campaign name"
          value={formData.name}
          onChange={(e) => onInputChange('name', e.target.value)}
          error={errors.name}
        />
      </Group>

      <Group>
        <Text fw={600}>Description:</Text>
        <TextInput
          required
          placeholder="Enter campaign description"
          value={formData.description}
          onChange={(e) => onInputChange('description', e.target.value)}
          error={errors.description}
        />
      </Group>
    </Stack>
  );
}

export default EditCampaignForm; 